import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-sm font-medium text-gray-700 mb-1" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = ["name", "id", "value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "fill-current h-5 w-5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" })
  ])
], -1)
const _hoisted_6 = {
  key: 0,
  class: "text-red-800 text-sm ml-0.5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col py-2 px-3 relative w-full", _ctx.tclass])
  }, [
    _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.label), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("select", _mergeProps({
        class: ["p-2 w-full border rounded-lg bg-white appearance-none focus:outline-none focus:ring-2 transition-colors duration-150", [
          _ctx.error && _ctx.error.length > 0 ? 'border-red-800' : 'border-gray-300',
          `focus:ring-${_ctx.theme}-200 focus:border-${_ctx.theme}-500`,
        ]],
        name: _ctx.name,
        id: _ctx.name,
        value: _ctx.value,
        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
      }, _ctx.$attrs), [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
          return (_openBlock(), _createElementBlock("option", {
            value: item.value,
            key: item.value
          }, _toDisplayString(item.name), 9, _hoisted_4))
        }), 128))
      ], 16, _hoisted_3),
      _hoisted_5
    ]),
    (_ctx.error && _ctx.error.length > 0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ], 2))
}